import { render, staticRenderFns } from "./SearchableDocumentsList.vue?vue&type=template&id=27ff2ebd"
import script from "./SearchableDocumentsList.vue?vue&type=script&lang=ts"
export * from "./SearchableDocumentsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ff2ebd')) {
      api.createRecord('27ff2ebd', component.options)
    } else {
      api.reload('27ff2ebd', component.options)
    }
    module.hot.accept("./SearchableDocumentsList.vue?vue&type=template&id=27ff2ebd", function () {
      api.rerender('27ff2ebd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/SearchableDocumentsList.vue"
export default component.exports